module.exports = __webpack_public_path__ + "static/media/animated-welcome-gif-8.98636c6e.gif";